import React, { useEffect } from 'react';
import { View } from 'react-native';
import BarcodeCameraView from '../../components/camera/BarcodeCameraView';

import { useThemedStyles } from '../../hooks/useThemedStyles';
import { Button, Dialog } from '../../components';
import Text from '../../components/text/Text';
import useBarcodeScanner from '../../hooks/useBarcodeScanner';

const StockDeliveryScannerDialog = ({
	isOpen,
	onClose,
	onBarcodeScanned,
}) => {
	const styles = useThemedStyles(createStyles);
	const {
		cameraPermission,
		requestCameraPermission,
		handleBarcodeScanned,
		resetScanner,
	} = useBarcodeScanner({
		onScanned: onBarcodeScanned,
	});

	useEffect(() => {
		if (isOpen) {
			requestCameraPermission();
		}
	}, [isOpen, requestCameraPermission]);

	useEffect(() => {
		if (!isOpen) {
			resetScanner();
		}
	}, [isOpen, resetScanner]);

	const renderScanner = () => {
		if (!cameraPermission) {
			return <Text style={styles.dialogMeta}>Requesting camera permission…</Text>;
		}

		if (!cameraPermission.granted) {
			return (
				<View style={styles.scannerPermission}>
					<Text style={styles.dialogMeta}>Camera access is required to scan barcodes.</Text>
					<Button
						label="Grant permission"
						onPress={requestCameraPermission}
					/>
				</View>
			);
		}

		return (
			<BarcodeCameraView
				style={styles.scannerCamera}
				onBarcodeScanned={handleBarcodeScanned}
			/>
		);
	};

	return (
		<Dialog
			isOpen={isOpen}
			onClose={onClose}
			noPadding={true}
		>
			<View style={styles.scannerContainer}>
				{renderScanner()}
				<Text style={styles.scannerHint}>
					Scan a product barcode to find it in this delivery.
				</Text>
			</View>
		</Dialog>
	);
};

const createStyles = ({ ui: { colors, type, space, radius } }) => ({
	scannerContainer: {
		height: 400,
		justifyContent: 'center',
		backgroundColor: colors.surface,
		borderRadius: radius.hero,
		overflow: 'hidden',
	},
	scannerHint: {
		...type.bodySmall,
		textAlign: 'center',
		marginTop: space.sm,
		color: colors.textSecondary,
		paddingHorizontal: space.lg,
	},
	scannerCamera: {
		height: 320,
	},
	scannerPermission: {
		alignItems: 'center',
		justifyContent: 'center',
		padding: space.lg,
		gap: space.sm,
	},
	dialogMeta: {
		...type.bodySmall,
		color: colors.textSecondary,
		marginBottom: space.sm,
	},
});

export default StockDeliveryScannerDialog;
